import { NgModule } from '@angular/core';

import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { NzTableModule } from 'ng-zorro-antd/table';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzCardModule } from 'ng-zorro-antd/card';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { NzDatePickerModule } from 'ng-zorro-antd/date-picker';
import { NzMessageModule } from 'ng-zorro-antd/message';
import { NzNotificationModule } from 'ng-zorro-antd/notification';
import { NzDrawerModule } from 'ng-zorro-antd/drawer';
import { NzBadgeModule } from 'ng-zorro-antd/badge';
import { NzFlexModule } from 'ng-zorro-antd/flex';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { NzMenuModule } from 'ng-zorro-antd/menu';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { NzRadioModule } from 'ng-zorro-antd/radio';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { NzIconModule, NZ_ICONS } from 'ng-zorro-antd/icon';
import { NzLayoutModule } from 'ng-zorro-antd/layout';
import { NzPageHeaderModule } from 'ng-zorro-antd/page-header';
import { NzCheckboxModule } from 'ng-zorro-antd/checkbox';
import { NzResultModule } from 'ng-zorro-antd/result';
import { NzListModule } from 'ng-zorro-antd/list';
import { NzTabsModule } from 'ng-zorro-antd/tabs';
import { NzAlertModule } from 'ng-zorro-antd/alert';
import { NzEmptyModule } from 'ng-zorro-antd/empty';
import { NzTreeSelectModule } from 'ng-zorro-antd/tree-select';
import { NzSkeletonModule } from 'ng-zorro-antd/skeleton';
import { NzPopconfirmModule } from 'ng-zorro-antd/popconfirm';
import { NzUploadModule } from 'ng-zorro-antd/upload';
import { NzTimelineModule } from 'ng-zorro-antd/timeline';
import { NzDescriptionsModule } from 'ng-zorro-antd/descriptions';
import { NzSpaceModule } from 'ng-zorro-antd/space';
import { NzSwitchModule } from 'ng-zorro-antd/switch';
import { NzInputNumberModule } from 'ng-zorro-antd/input-number';
import { NzTreeViewModule } from 'ng-zorro-antd/tree-view';
import { NzTimePickerModule } from 'ng-zorro-antd/time-picker';
import { NzTagModule }from'ng-zorro-antd/tag';
import { NzMentionModule } from 'ng-zorro-antd/mention';
import { NzPopoverModule } from 'ng-zorro-antd/popover';
import { NzAffixModule } from 'ng-zorro-antd/affix';
import { NzStepsModule } from 'ng-zorro-antd/steps';
import { NzTreeModule } from 'ng-zorro-antd/tree';
import { NzTypographyModule } from 'ng-zorro-antd/typography';
import { NzProgressModule } from 'ng-zorro-antd/progress';
import { NzCollapseModule } from 'ng-zorro-antd/collapse';
import { NzBreadCrumbModule } from 'ng-zorro-antd/breadcrumb';
import * as nzIcons from '@ant-design/icons-angular/icons';
const icons = Object.values(nzIcons).filter(icon => !!icon);

@NgModule({
  exports: [
    NzButtonModule,
    NzGridModule,
    NzTableModule,
    NzInputModule,
    NzFormModule,
    NzCardModule,
    NzModalModule,
    NzSelectModule,
    NzSpinModule,
    NzDatePickerModule,
    NzMessageModule,
    NzNotificationModule,
    NzDrawerModule,
    NzBadgeModule,
    NzFlexModule,
    NzIconModule,
    NzLayoutModule,
    NzMenuModule,
    NzDividerModule,
    NzRadioModule,
    NzToolTipModule,
    NzDropDownModule,
    NzPageHeaderModule,
    NzCheckboxModule,
    NzResultModule,
    NzListModule,
    NzTabsModule,
    NzAlertModule,
    NzEmptyModule,
    NzTreeSelectModule,
    NzSkeletonModule,
    NzPopconfirmModule,
    NzUploadModule,
    NzTimelineModule,
    NzDescriptionsModule,
    NzSpaceModule,
    NzSwitchModule,
    NzInputNumberModule,
    NzTreeViewModule,
    NzTimePickerModule,
    NzMentionModule,
    NzTagModule,
    NzPopoverModule,
    NzAffixModule,
    NzStepsModule,
    NzTreeModule,
    NzTypographyModule,
    NzProgressModule,
    NzCollapseModule,
    NzBreadCrumbModule
  ],
  providers: [
    { provide: NZ_ICONS, useValue: icons }
  ]
})
export class NgZorroModule {}
